import React, { useEffect, useRef, useState } from 'react';
import { STATS } from '../data/mock';
import Section, { useInView } from './Section';

function Counter({ value }) {
  const [ref, inView] = useInView(0.4);
  const [display, setDisplay] = useState(value);
  useEffect(() => {
    if (!inView) return;
    // Animate numeric portion only
    const match = value.match(/([0-9]+\.?[0-9]*)(.*)/);
    if (!match) return;
    const target = parseFloat(match[1]);
    const suffix = match[2];
    let cur = 0;
    const dur = 1400;
    const start = performance.now();
    let raf;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      cur = target * eased;
      setDisplay(`${Number.isInteger(target) ? Math.round(cur) : cur.toFixed(1)}${suffix}`);
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value]);
  return <span ref={ref} className="ticker-num text-white">{display}</span>;
}

export default function StatsBand() {
  return (
    <Section
      id="programs"
      eyebrow="By The Numbers"
      title={(
        <>
          Performance,<br />Measured Honestly.
        </>
      )}
      lead="We publish what we move. Every metric below reflects deployed cohorts, not pilots. Audited quarterly, refreshed continuously."
    >
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/8 rounded-2xl overflow-hidden border border-white/8">
        {STATS.map((s, i) => (
          <div key={i} className="bg-black p-8 lg:p-10">
            <div className="pin-num mb-6">0{i + 1}</div>
            <Counter value={s.value} />
            <div className="mt-4 text-white/55 text-[13.5px] leading-[1.6]">{s.label}</div>
          </div>
        ))}
      </div>
    </Section>
  );
}
